<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

    <fg-input type="text"
              label="Name"
              placeholder="Name"
              v-model="company.profile.name"/>

    <span slot="footer" class="dialog-footer">
      <button class="btn btn-danger" @click="$emit('cancel')">Cancel</button>&nbsp;
      <button class="btn btn-success" @click="$emit('save', user)">Confirm</button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Edit-Affiliate-Company',
  props: {
    visible: Boolean,
    mode: String
  },
  data () {
    return {
      company: {
        name: ''
      }
    }
  },
  computed: {
    title () {
      return this.mode + ' Affiliate Company'
    }/* ,
    dialogVisible () {
      return this.visible
    } */
  },
  methods: {
    closeModal () {
      this.$emit('cancel')
    }
  }
}
</script>

<style>

</style>